import React from 'react';
import { ChecklistContentfulModel } from 'src/api/models/Checklist';
import Checklist from 'src/molecules/checklist/checklist';

export default function getDynamicChecklist(checklistProps: ChecklistContentfulModel): React.ReactNode {
  return <Checklist items={checklistProps.items} />
}
